import { z } from 'zod'

export const startSettlementRoundSchema = z.object({
  dateFrom: z.string().datetime({ offset: true }),
  dateTo: z.string().datetime({ offset: true }),
  accountId: z.string().guid(),
  skipBalanceAdjustment: z.boolean().optional().default(false),
})

export type StartSettlementRoundDto = z.infer<typeof startSettlementRoundSchema>
